import AppComponent from '../base/app-component.ts';
import { apiGet } from '../lib/api-client.ts';

interface CategoriaRow {
  codice: string;
  nome: string;
  ordine: number;
}

// Cache statica per evitare un fetch a ogni componente montato.
let cache: Promise<CategoriaRow[]> | null = null;

async function fetchCategorie(): Promise<CategoriaRow[]> {
  if (!cache) {
    cache = apiGet<{ categorie: CategoriaRow[] }>('categorie-iscrizione').then(r =>
      r.ok ? r.data.categorie : [],
    );
  }
  return cache;
}

/**
 * wc-categoria-select - Dropdown delle categorie iscrizione non-EDC.
 *
 * Attributi:
 *   value         valore preselezionato (codice categoria)
 *   name          attributo name del <select> (default "categoria")
 *   placeholder   testo opzione vuota (default "-- seleziona --")
 *   required      se presente, l'opzione vuota e' disabilitata
 *
 * Eventi:
 *   change        bubblato dal <select> interno
 */
export class CategoriaSelect extends AppComponent {
  static override componentName = 'wc-categoria-select';

  static override get observedAttributes(): string[] { return ['value']; }

  protected override get templateId() { return 'categoria-select'; }

  protected override async afterRender(): Promise<void> {
    const select = this.$('select') as HTMLSelectElement | null;
    if (!select) return;

    const rows = await fetchCategorie();
    const value = this.attributeString('value');
    const placeholder = this.attributeString('placeholder', '-- seleziona --');
    const required = this.hasAttribute('required');

    const opts: string[] = [
      `<option value="" ${required ? 'disabled' : ''} ${value ? '' : 'selected'}>${placeholder}</option>`,
    ];
    for (const r of rows) {
      const sel = r.codice === value ? 'selected' : '';
      opts.push(`<option value="${r.codice}" ${sel}>${r.codice} - ${r.nome}</option>`);
    }
    select.innerHTML = opts.join('');
  }

  protected override onAttributeChanged(name: string, _old: string | null, val: string | null): void {
    if (name !== 'value') return;
    const select = this.$('select') as HTMLSelectElement | null;
    if (select) select.value = val ?? '';
  }

  /** Valore corrente del select (codice categoria o ''). */
  get value(): string {
    return (this.$('select') as HTMLSelectElement | null)?.value ?? '';
  }

  set value(v: string) {
    const select = this.$('select') as HTMLSelectElement | null;
    if (select) select.value = v;
  }
}
